<template>
  <login-form
    @onLogin="onLogin($event)"
    :isPending="loginPending"
    :hasFailed="loginFailed">
  </login-form>
</template>

<script>
import { mapState } from 'vuex';

import LoginForm from '@/components/auth/LoginForm';

export default {
  name: 'LoginContainer',
  components: {
    LoginForm,
  },
  computed: {
    ...mapState('auth', [
      'loginPending',
      'loginFailed',
      'loginSucceeded',
      'isLoggedIn',
    ]),
    ...mapState('user', ['me']),
  },
  methods: {
    onLogin(event) {
      this.$store.dispatch('auth/login', {
        email: event.email,
        password: event.password,
      });
    },
  },
  watch: {
    me() {
      if (this.me) {
        this.$router.push({ name: 'Dashboard' });
      }
    },
    isLoggedIn() {
      if (this.isLoggedIn) {
        this.$router.push({ name: 'Dashboard' });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// LoginContainer.vue?4a948de5